import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TagProps {
  name: string;
  onRemove?: () => void;
  className?: string;
  variant?: 'default' | 'outline';
}

export function Tag({ name, onRemove, className, variant = 'default' }: TagProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium',
        variant === 'default' && 'bg-primary/10 text-primary hover:bg-primary/20',
        variant === 'outline' && 'border border-input bg-background hover:bg-accent',
        className
      )}
    >
      {name}
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-1 rounded-sm hover:bg-primary/30 focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
